var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat3NewHair2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat3_6_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F3C1B",
    d: "M541,137.2c-1.3-19.4-35.1-19.7-50-20.7c-43.5-3.1-86,4.9-130.5,4.6c-31.2-0.2-64.4-3.5-98.3-6.3l-4-0.6 c-13.2-1.9-36.9,1.2-50.6,4.6c-15.9,4-37.8,15.7-25.9,35.7c7.7,12.9,33.2,28.5,46.6,34c17.9,7.3,31.7,12.1,50.6,16.6 c37.6,8.8,76.6,5.4,114.4,0.7c38.6-4.8,76-12.9,111.6-31C518.6,167.8,542.3,155.7,541,137.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F3C1B",
    d: "M444.6,54.5c-10.2-5.2-23.3-8.1-33.7-12.7C400,37.1,394.4,28.2,384,22c-22.5-13.4-55,3-74.3,16 c-24.5,16.6-41,5.5-57.5,26.5c-8,10.1-8.8,25.1-9.2,37.6c-0.2,7.7,0.4,20.2,1.3,31.5c1.5,1,2.9,1.9,4.4,2.8 c58.8,35.3,137,38.7,200.6,11c6.1-2.8,12.1-5.9,17.9-9.4c1.5-0.9,2.9-1.8,4.4-2.7c-0.2-4.7-0.4-9.1-0.7-12.1 C468.7,97.5,471.4,68.1,444.6,54.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCB37F",
    d: "M469.4,100.6c-0.9,0.4-1.9,0.9-2.8,1.3c-6,2.7-12.1,5.2-18.3,7.5c-61.4,21-130.4,19.9-190.2-4.8 c-5-2.1-10-4.4-14.9-6.8c-0.1,1.5-0.1,3-0.2,4.4c-0.2,7.7,0.4,20.2,1.3,31.5c1.5,1,2.9,1.9,4.4,2.8c58.8,35.3,137,38.7,200.6,11 c6.1-2.8,12.1-5.9,17.9-9.4c1.5-0.9,2.9-1.8,4.4-2.7c-0.2-4.7-0.4-9.1-0.7-12.1C470.4,115.8,470.1,108.1,469.4,100.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M361.6,77.4c22.2-3.4,37.5-18.3,50.8-34.8c-0.5-0.2-1-0.4-1.6-0.7C400,37.1,394.4,28.2,384,22 c-22.5-13.4-55,3-74.3,16c-4.3,2.9-8.3,4.9-12.1,6.5c1.3,2.4,2.7,4.7,4.3,6.9C314.5,70.5,338.7,80.8,361.6,77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M471.7,135.3c-0.2-4.7-0.4-9.1-0.7-12.1c-2.1-22.7-0.2-48.2-18.2-63.3c-6.1,27.8,0.8,56.2,4,83.9 c3.5-1.8,7-3.7,10.5-5.8C468.8,137.2,470.3,136.3,471.7,135.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M278.8,82c41.4,25.4,102.4,26.5,142.6-2.3c-13.8,27.6-57.3,31.3-84.9,29C312.4,106.3,297.3,99.2,278.8,82"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE7B6",
    d: "M326.6,122.2c-7.7,12-13.8,22.7-24.4,36.5c3.8,1,7.7,1.9,11.5,2.7c11-14.4,17.1-25.4,25.3-38 C334.9,123.1,330.8,122.7,326.6,122.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE7B6",
    d: "M377.3,123.5c-9.2,13.8-19.8,29.6-30.6,42.1c15.8,0.9,31.7,0.1,47.4-2.3c9.3-14.1,17.9-31.3,25.5-45.9 C405.7,120.5,391.6,122.6,377.3,123.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat3NewHair2);
export default __webpack_public_path__ + "static/media/m-hat3_new-hair2.0d2684df5621567e20bac9e9f5ca74da.svg";
export { ForwardRef as ReactComponent };